<template>
    <div>
        <component v-for="(field) in schema"
                   :key="field.id"
                   :is="typeMapping[field.type]"
                   :meta="field.meta"
                   :value="formData.contentDataSet[field.name] ? formData.contentDataSet[field.name].value : {}"
                   @input="updateForm(field.name, $event)"
                   v-bind="field">
        </component>
    </div>
</template>

<script>
    import TextInput from "./TextInput";
    import ImageInput from "./ImageInput";
    import HtmlInput from "./HtmlInput";
    import TextArea from "./TextArea";
    import BoolInput from "./BoolInput";
    import DateInput from "./DateInput";
    import DesignShopTile from "./DesignShopTile";
    import DesignShopTileList from "./DesignShopTileList";
    import TrendShopTile from "./TrendShopTile";
    import CategorySelect from "./CategorySelect";
    import DesignShopTileSelect from "./DesignShopTileSelect";
    import ImageGrid from "./ImageGrid";
    import SimpleList from "./SimpleList";

    export default {
        name: "FormGenerator",
        components: {TextInput, ImageInput, BoolInput},
        props: ['schema', 'value', 'submitCallback'],
        data() {
            return {
                formData: this.value || {},
                typeMapping: {
                    'TEXT': TextInput,
                    'IMAGE': ImageInput,
                    'HTML': HtmlInput,
                    'LONG_TEXT': TextArea,
                    'BOOL': BoolInput,
                    'DATE': DateInput,
                    'TREND_SHOP_TILE': TrendShopTile,
                    'DESIGN_SHOP_TILE': DesignShopTile,
                    'DESIGN_SHOP_TILE_LIST': DesignShopTileList,
                    'CATEGORY_SELECT': CategorySelect,
                    'DESIGN_SHOP_TILE_SELECT': DesignShopTileSelect,
                    'SIMPLE_LIST': SimpleList,
                    'IMAGE_GRID': ImageGrid
                }
            };
        },
        watch: {
            value: function (newFormData) {
                this.formData = newFormData;
            }
        },
        methods: {
            updateForm(fieldName, value) {
                this.$set(this.formData.contentDataSet[fieldName], "value", value);
                this.$emit('input', this.formData)
            }
        }
    };
</script>